import React from "react";
var __jsx = React.createElement;
import { TaskActionsContext } from "./task-actions-context";
/** Injects action-centre handler overrides into the subtree (used by the legacy task modal). */
export function TaskActionsProvider(_ref) {
  var actions = _ref.actions,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(TaskActionsContext.Provider, {
    value: actions
  }, children);
}